import type { ThemeConfig } from 'antd';

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#0d9488',
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    colorTextBase: '#374151',
    colorTextSecondary: '#9ca3af',
    colorBgContainer: '#ffffff',
    borderRadius: 12,
    colorBgLayout: '#f3f4f6',
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      headerHeight: 64,
      headerPadding: '0 24px',
      siderBg: '#ffffff',
      triggerBg: '#ffffff',
      triggerColor: '#374151',
    },
    Table: {
      headerBg: '#f9fafb',
      headerColor: '#374151',
      headerSplitColor: '#e5e7eb',
      borderColor: '#e5e7eb',
    },
    Card: {
      borderRadius: 12,
    },
    Menu: {
      itemBg: '#ffffff',
      itemSelectedBg: '#ccfbf1',
      itemSelectedColor: '#0d9488',
      itemHoverBg: '#f3f4f6',
      itemHoverColor: '#374151',
    },
  },
};
